import debounce from 'lodash/debounce'
import { onBeforeUnmount, onMounted } from 'vue'
import { useHeightStore } from '@app/shared/vue/store/height-store'

function useHeightObserver(): void {
  const { updateHeights } = useHeightStore()
  const debouncedUpdate = debounce(updateHeights, 100, { trailing: true })

  const styleObserver = new MutationObserver(debouncedUpdate)

  onMounted(() => {
    styleObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['style'],
    })
  })

  onBeforeUnmount(() => {
    styleObserver.disconnect()
    debouncedUpdate.cancel()
  })
}

export default useHeightObserver
